"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[69],{

/***/ 98968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "aN": function() { return /* binding */ PromptSupportingLanguageMap; }
/* harmony export */ });
/* unused harmony exports ImageCreateResponseFormat, ResponseTone, WritingStyle, PromptInterfaceFragmentDoc, VisitorChromeExtensionPromptResponseFragmentDoc, VisitorChromeExtensionPromptResponseWithPromptDetailFragmentDoc, VisitorFetchPromptsDocument, VisitorFetchPromptsForChromeExtensionDocument, VisitorFetchPromptsForChromeExtensionWithPromptDetailDocument, VisitorGeneratePromptDocument, getSdk */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39011);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31230);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment PromptInterface on PromptInterface {\n    id\n    promptHint\n    promptTeaser\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment VisitorChromeExtensionPromptResponse on ChromeExtensionPromptResponse {\n    id\n    title\n    category\n    promptHint\n    promptTeaser\n    createdAt\n    updatedAt\n    statistics {\n      usages\n      views\n      votes\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment VisitorChromeExtensionPromptResponseWithPromptDetail on ChromeExtensionPromptResponse {\n    ...VisitorChromeExtensionPromptResponse\n    prompt\n  }\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query visitorFetchPrompts @cached(ttl: 300) {\n    prompts {\n      ...PromptInterface\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query visitorFetchPromptsForChromeExtension @cached(ttl: 300) {\n    promptsForChromeExtension {\n      ...VisitorChromeExtensionPromptResponse\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query visitorFetchPromptsForChromeExtensionWithPromptDetail @cached(ttl: 300) {\n    promptsForChromeExtension {\n      ...VisitorChromeExtensionPromptResponseWithPromptDetail\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query visitorGeneratePrompt(\n    $language: PromptSupportingLanguageMap!\n    $prompt: String!\n    $promptId: String!\n  ) {\n    generatePrompt(prompt: $prompt, promptId: $promptId, language: $language) {\n      id\n      language\n      prompt\n      createResponse {\n        created\n        id\n        model\n        object\n        usage {\n          completion_tokens\n          prompt_tokens\n          total_tokens\n        }\n        choices {\n          finish_reason\n          index\n          text\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var ImageCreateResponseFormat;
(function(ImageCreateResponseFormat) {
    ImageCreateResponseFormat["B64Json"] = "b64_json";
    ImageCreateResponseFormat["Url"] = "url";
})(ImageCreateResponseFormat || (ImageCreateResponseFormat = {}));
var PromptSupportingLanguageMap;
(function(PromptSupportingLanguageMap) {
    PromptSupportingLanguageMap["Arabic"] = "Arabic";
    PromptSupportingLanguageMap["Bulgarian"] = "Bulgarian";
    PromptSupportingLanguageMap["Catalan"] = "Catalan";
    PromptSupportingLanguageMap["Chinese"] = "Chinese";
    PromptSupportingLanguageMap["Czech"] = "Czech";
    PromptSupportingLanguageMap["Danish"] = "Danish";
    PromptSupportingLanguageMap["Dutch"] = "Dutch";
    PromptSupportingLanguageMap["English"] = "English";
    PromptSupportingLanguageMap["Finnish"] = "Finnish";
    PromptSupportingLanguageMap["French"] = "French";
    PromptSupportingLanguageMap["German"] = "German";
    PromptSupportingLanguageMap["Greek"] = "Greek";
    PromptSupportingLanguageMap["Hebrew"] = "Hebrew";
    PromptSupportingLanguageMap["Hindi"] = "Hindi";
    PromptSupportingLanguageMap["Hungarian"] = "Hungarian";
    PromptSupportingLanguageMap["Indonesian"] = "Indonesian";
    PromptSupportingLanguageMap["Italian"] = "Italian";
    PromptSupportingLanguageMap["Japanese"] = "Japanese";
    PromptSupportingLanguageMap["Korean"] = "Korean";
    PromptSupportingLanguageMap["MandarinChinese"] = "MandarinChinese";
    PromptSupportingLanguageMap["Norwegian"] = "Norwegian";
    PromptSupportingLanguageMap["Polish"] = "Polish";
    PromptSupportingLanguageMap["Portuguese"] = "Portuguese";
    PromptSupportingLanguageMap["Romanian"] = "Romanian";
    PromptSupportingLanguageMap["Russian"] = "Russian";
    PromptSupportingLanguageMap["Serbian"] = "Serbian";
    PromptSupportingLanguageMap["Spanish"] = "Spanish";
    PromptSupportingLanguageMap["Swedish"] = "Swedish";
    PromptSupportingLanguageMap["Thai"] = "Thai";
    PromptSupportingLanguageMap["Turkish"] = "Turkish";
    PromptSupportingLanguageMap["Ukrainian"] = "Ukrainian";
    PromptSupportingLanguageMap["Vietnamese"] = "Vietnamese";
})(PromptSupportingLanguageMap || (PromptSupportingLanguageMap = {}));
var ResponseTone;
(function(ResponseTone) {
    ResponseTone["Authoritative"] = "Authoritative";
    ResponseTone["Clinical"] = "Clinical";
    ResponseTone["Cold"] = "Cold";
    ResponseTone["Confident"] = "Confident";
    ResponseTone["Cynical"] = "Cynical";
    ResponseTone["Emotional"] = "Emotional";
    ResponseTone["Empathetic"] = "Empathetic";
    ResponseTone["Formal"] = "Formal";
    ResponseTone["Friendly"] = "Friendly";
    ResponseTone["Humorous"] = "Humorous";
    ResponseTone["Informal"] = "Informal";
    ResponseTone["Ironic"] = "Ironic";
    ResponseTone["Label"] = "Label";
    ResponseTone["Optimistic"] = "Optimistic";
    ResponseTone["Pessimistic"] = "Pessimistic";
    ResponseTone["Playful"] = "Playful";
    ResponseTone["Sarcastic"] = "Sarcastic";
    ResponseTone["Serious"] = "Serious";
    ResponseTone["Sympathetic"] = "Sympathetic";
    ResponseTone["Tentative"] = "Tentative";
    ResponseTone["Warm"] = "Warm";
})(ResponseTone || (ResponseTone = {}));
var WritingStyle;
(function(WritingStyle) {
    WritingStyle["Academic"] = "Academic";
    WritingStyle["Analytical"] = "Analytical";
    WritingStyle["Argumentative"] = "Argumentative";
    WritingStyle["Conversational"] = "Conversational";
    WritingStyle["Creative"] = "Creative";
    WritingStyle["Critical"] = "Critical";
    WritingStyle["Descriptive"] = "Descriptive";
    WritingStyle["Epigrammatic"] = "Epigrammatic";
    WritingStyle["Epistolary"] = "Epistolary";
    WritingStyle["Expository"] = "Expository";
    WritingStyle["Informative"] = "Informative";
    WritingStyle["Instructive"] = "Instructive";
    WritingStyle["Journalistic"] = "Journalistic";
    WritingStyle["Label"] = "Label";
    WritingStyle["Metaphorical"] = "Metaphorical";
    WritingStyle["Narrative"] = "Narrative";
    WritingStyle["Persuasive"] = "Persuasive";
    WritingStyle["Poetic"] = "Poetic";
    WritingStyle["Satirical"] = "Satirical";
    WritingStyle["Technical"] = "Technical";
})(WritingStyle || (WritingStyle = {}));
var PromptInterfaceFragmentDoc = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject());
var VisitorChromeExtensionPromptResponseFragmentDoc = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject1());
var VisitorChromeExtensionPromptResponseWithPromptDetailFragmentDoc = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject2(), VisitorChromeExtensionPromptResponseFragmentDoc);
var VisitorFetchPromptsDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject3(), PromptInterfaceFragmentDoc);
var VisitorFetchPromptsForChromeExtensionDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject4(), VisitorChromeExtensionPromptResponseFragmentDoc);
var VisitorFetchPromptsForChromeExtensionWithPromptDetailDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject5(), VisitorChromeExtensionPromptResponseWithPromptDetailFragmentDoc);
var VisitorGeneratePromptDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject6());
var defaultWrapper = function(action, _operationName, _operationType) {
    return action();
};
var VisitorFetchPromptsDocumentString = (0,graphql__WEBPACK_IMPORTED_MODULE_2__/* .print */ .S)(VisitorFetchPromptsDocument);
var VisitorFetchPromptsForChromeExtensionDocumentString = (0,graphql__WEBPACK_IMPORTED_MODULE_2__/* .print */ .S)(VisitorFetchPromptsForChromeExtensionDocument);
var VisitorFetchPromptsForChromeExtensionWithPromptDetailDocumentString = (0,graphql__WEBPACK_IMPORTED_MODULE_2__/* .print */ .S)(VisitorFetchPromptsForChromeExtensionWithPromptDetailDocument);
var VisitorGeneratePromptDocumentString = (0,graphql__WEBPACK_IMPORTED_MODULE_2__/* .print */ .S)(VisitorGeneratePromptDocument);
function getSdk(client) {
    var withWrapper = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultWrapper;
    return {
        visitorFetchPrompts: function visitorFetchPrompts(variables, requestHeaders) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.rawRequest(VisitorFetchPromptsDocumentString, variables, _object_spread({}, requestHeaders, wrappedRequestHeaders));
            }, "visitorFetchPrompts", "query");
        },
        visitorFetchPromptsForChromeExtension: function visitorFetchPromptsForChromeExtension(variables, requestHeaders) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.rawRequest(VisitorFetchPromptsForChromeExtensionDocumentString, variables, _object_spread({}, requestHeaders, wrappedRequestHeaders));
            }, "visitorFetchPromptsForChromeExtension", "query");
        },
        visitorFetchPromptsForChromeExtensionWithPromptDetail: function visitorFetchPromptsForChromeExtensionWithPromptDetail(variables, requestHeaders) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.rawRequest(VisitorFetchPromptsForChromeExtensionWithPromptDetailDocumentString, variables, _object_spread({}, requestHeaders, wrappedRequestHeaders));
            }, "visitorFetchPromptsForChromeExtensionWithPromptDetail", "query");
        },
        visitorGeneratePrompt: function visitorGeneratePrompt(variables, requestHeaders) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.rawRequest(VisitorGeneratePromptDocumentString, variables, _object_spread({}, requestHeaders, wrappedRequestHeaders));
            }, "visitorGeneratePrompt", "query");
        }
    };
}


/***/ }),

/***/ 29608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ RootStyle; },
/* harmony export */   "k": function() { return /* binding */ TopLandingSection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_animate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76843);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2734);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(40549);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15861);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32970);







var TopLandingSection = function(props) {
    var _title = props.title, title = _title === void 0 ? "" : _title, titleColor = props.titleColor, _subtitle = props.subtitle, subtitle = _subtitle === void 0 ? "" : _subtitle, subtitleColor = props.subtitleColor, subtitleFontSize = props.subtitleFontSize;
    var theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    if (title === "" && subtitle === "") return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        sx: {
            textAlign: "center",
            mb: 5
        },
        id: title,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_4__.m.div, {
                variants: (0,_components_animate__WEBPACK_IMPORTED_MODULE_1__/* .varFade */ .EU)().inUp,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    variant: "h3",
                    sx: {
                        mb: 2,
                        color: titleColor !== null && titleColor !== void 0 ? titleColor : theme.palette.primary.main
                    },
                    children: title
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_4__.m.div, {
                variants: (0,_components_animate__WEBPACK_IMPORTED_MODULE_1__/* .varFade */ .EU)().inDown,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    variant: "body1",
                    sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                        mb: 2,
                        color: subtitleColor !== null && subtitleColor !== void 0 ? subtitleColor : theme.palette.grey[600]
                    }, subtitleFontSize ? {
                        fontSize: subtitleFontSize
                    } : {}),
                    children: subtitle
                })
            })
        ]
    });
};
var RootStyle = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)("div")(function(param) {
    var theme = param.theme, backgroundColor = param.backgroundColor, backgroundImage = param.backgroundImage;
    return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        backgroundColor: backgroundColor || theme.palette.background.neutral,
        backgroundImage: backgroundImage,
        padding: theme.spacing(10, 2)
    }, theme.breakpoints.up("md"), {
        padding: theme.spacing(12, 0)
    });
});


/***/ }),

/***/ 76271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Eh": function() { return /* binding */ decodeID; },
/* harmony export */   "J1": function() { return /* binding */ formatPromptsPageUrl; },
/* harmony export */   "Pb": function() { return /* binding */ formatPrompt; },
/* harmony export */   "SP": function() { return /* binding */ currentConcurrentCountVar; },
/* harmony export */   "U9": function() { return /* binding */ shouldDisableMagicButton; },
/* harmony export */   "_7": function() { return /* binding */ UseCase; },
/* harmony export */   "fW": function() { return /* binding */ systemLocaleTransformer; },
/* harmony export */   "k9": function() { return /* binding */ PlanType; },
/* harmony export */   "kt": function() { return /* binding */ getConcurrentCountByPlanType; },
/* harmony export */   "uj": function() { return /* binding */ languageTransformer; }
/* harmony export */ });
/* unused harmony exports encodeID, plans, constantPromptTransform, getPromptFromStaticPrompt, midjourneyPromptParamsVersionMap, getCreateImagePrompt */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _appConfig__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83330);
/* harmony import */ var _generated_graphql_prompts_node__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98968);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34088);
/* harmony import */ var buffer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48764);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15983);
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13311);
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_find__WEBPACK_IMPORTED_MODULE_4__);







var PlanType;
(function(PlanType) {
    PlanType["free"] = "free";
    PlanType["basic"] = "basic";
    PlanType["premium"] = "premium";
})(PlanType || (PlanType = {}));
// Function to encode ID
function encodeID(id) {
    var buffer = Buffer.from(id, "utf-8");
    return buffer.toString("base64");
}
// Function to decode ID
function decodeID(encodedId) {
    var buffer = buffer__WEBPACK_IMPORTED_MODULE_3__.Buffer.from(encodedId, "base64");
    return buffer.toString("utf-8");
}
var plans = [
    {
        type: PlanType.free,
        concurrent: 3
    },
    {
        type: PlanType.basic,
        concurrent: 5
    },
    {
        type: PlanType.premium,
        concurrent: 7
    }, 
];
var ref;
var getConcurrentCountByPlanType = function(planType) {
    var ref1;
    return (ref = (ref1 = lodash_find__WEBPACK_IMPORTED_MODULE_4___default()(plans, {
        type: planType
    })) === null || ref1 === void 0 ? void 0 : ref1.concurrent) !== null && ref !== void 0 ? ref : 1;
};
var shouldDisableMagicButton = function(params) {
    var ref;
    var planType = params.planType, currentConcurrentCount = params.currentConcurrentCount;
    var ref1;
    return ((ref1 = (ref = lodash_find__WEBPACK_IMPORTED_MODULE_4___default()(plans, {
        type: planType
    })) === null || ref === void 0 ? void 0 : ref.concurrent) !== null && ref1 !== void 0 ? ref1 : 1) <= currentConcurrentCount;
};
var currentConcurrentCountVar = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .makeVar */ .QS)(0);
var languageTransformer = function(language) {
    return {
        label: language === _generated_graphql_prompts_node__WEBPACK_IMPORTED_MODULE_1__/* .PromptSupportingLanguageMap.MandarinChinese */ .aN.MandarinChinese ? "Mandarin Chinese" : language,
        id: language,
        value: language
    };
};
var formatPromptsPageUrl = function(params) {
    return "/app/".concat(_appConfig__WEBPACK_IMPORTED_MODULE_0__/* .AppServiceEnum.prompts */ .$3.prompts, "?").concat(query_string__WEBPACK_IMPORTED_MODULE_2__/* ["default"].stringify */ .Z.stringify((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, params)));
};
var UseCase;
(function(UseCase) {
    UseCase["text"] = "text";
    UseCase["image"] = "image";
    UseCase["video"] = "video";
})(UseCase || (UseCase = {}));
var constantPromptTransform = function(prompt) {
    return {
        id: prompt.ID,
        prompt: prompt.Prompt,
        promptHint: prompt.PromptHint,
        promptTeaser: prompt.Teaser,
        createdAt: prompt.CreationTime,
        updatedAt: prompt.RevisionTime,
        statistics: {
            usages: prompt.Usages,
            views: prompt.Views,
            votes: prompt.Votes
        }
    };
};
var getPromptFromStaticPrompt = function(params) {
    var staticPrompt = params.staticPrompt, userPrompt = params.userPrompt, language = params.language, _tags = params.tags, tags = _tags === void 0 ? [] : _tags;
    var result = staticPrompt.Prompt.replace(/\[Please ignore all previous instructions\]/g, "").replace(/\[TARGETLANGUAGE\]/g, language).replace(/\[PROMPT\]/g, userPrompt).replace(/\[TAGS\]/g, tags.join(", "));
    return result;
};
var formatPrompt = function(params) {
    var promptString = params.promptString, language = params.language, userPrompt = params.userPrompt, writeStyle = params.writeStyle, responseTone = params.responseTone;
    var result = promptString.replace(/\[TARGETLANGUAGE\]/g, language).replace(/\[PROMPT\]/g, userPrompt);
    var textToAddAtTheEnd = "\n  ".concat(writeStyle ? "The writing style should be ".concat(writeStyle, " and is written by a human") : "", "\n  ").concat(responseTone ? "The response tone should be ".concat(responseTone, " and is written by a human") : "", "\n  \n  ");
    return "".concat(result, "\n  ").concat(textToAddAtTheEnd, "\n  ").trim();
};
var midjourneyPromptParamsVersionMap;
(function(midjourneyPromptParamsVersionMap) {
    midjourneyPromptParamsVersionMap["v1"] = "v1";
    midjourneyPromptParamsVersionMap["v2"] = "v2";
})(midjourneyPromptParamsVersionMap || (midjourneyPromptParamsVersionMap = {}));
var getCreateImagePrompt = function(params) {
    var concept = params.concept, version = params.version;
    var latestMagicString = "\nwrite without wordwraps, headlines, connection words. Write back to back separated with commas and spaces:\n[1], [2], [3], [4], [5], [6]\n\nreplace [1] with a ".concat(concept, '\nreplace [2] with a concise, descriptive summary of [1]. Ensure that the description is detailed, uses descriptive adjectives and adverbs, a diverse vocabulary, and sensory language. Offer context and background information regarding the subject and consider the image\'s perspective and point of view. Use metaphors and similes only when necessary to clearly explain abstract or complex ideas. Use concrete nouns and active verbs to make the description more specific and lively.\nreplace [3] with a concise summary of the scene\'s environment. Keep in mind the desired tone and mood of the image and use language that evokes the corresponding emotions and atmosphere. Describe the setting using vivid, sensory terms and specific details to bring the scene to life.\nreplace [4] with a concise description of the mood of the scene, using language that conveys the desired emotions and atmosphere.\nreplace [5] with a concise description of the atmosphere, using descriptive adjectives and adverbs to create the desired atmosphere while considering the overall tone and mood of the image.\nreplace [6] with a concise description of the lighting effect, including types of lights, displays, styles, techniques, global illumination, and shadows. Describe the quality, direction, color, and intensity of the light and how it impacts the mood and atmosphere of the scene. Use specific adjectives and adverbs to portray the desired lighting effect and consider how it will interact with the subject and environment.\n\nEnsure word count limit of 1,500 words\nThe prompt should include the end arguments "--c X --s Y --q 2," where X is a whole number between 1 and 25 and Y is a whole number between 100 and 1000. \nIf the subject looks better vertically, add "--ar 2:3" before "--c," and if it looks better horizontally, add "--ar 3:2" before "--c." \nPlease randomize the end argument format and fix "--q 2." \nDo not use double quotation marks or punctuation marks, and use a randomized end suffix format.\nStart the prompt with exact words of "/imagine prompt: "\n\nnow generate the prompt in English*\n    ');
    var magicStr = "";
    switch(version){
        case midjourneyPromptParamsVersionMap.v1:
            {
                magicStr = "\nwrite without wordwraps, headlines, connection words. Write back to back separated with commas and spaces:\n\n[1], [2], [3], [4], [5]\n\nreplace [1] with a ".concat(concept, '\nreplace [2] with a list of detailed descriptions about [1]\nreplace [3] with a list of detailed descriptions about the environment of the scene\nreplace [4] with a list of detailed descriptions about the mood/feelings and atmosphere of the scene\nreplace [5] with a list of detailed descriptions about the way the prompt should be realized (e.g. Photography (e.g. Macro, Fisheye Style, Portrait) with camera model and according settings, Painting with detailed descriptions about the materials and working material used, rendering with engine settings, a digital Illustration, a woodburn art (and everything else that could be defined as an output type)\n\nshort prompt for an AI-based text to image program that converts a prompt about a topic into an image. Combine a wide variety of rare and commonly used words.\n\nalways start the prompt with "/imagine prompt: "\nalways end the prompt with " --v 4"\nnever write anything that is in [] brackets\ndon\'t use any line breaks\n\nwhen the prompt subject looks better vertically, add "--ar 2:3" before "--v 4".\nWhen the subject looks better horizontally, use "--ar 3:2" instead.\nWhen the subject looks better in a square, use "--ar 1:1" instead.\n\nnow generate the prompt in English*\n      ');
                break;
            }
        case midjourneyPromptParamsVersionMap.v2:
            {
                magicStr = '\n"Create an "imagine prompt" with a word count limit of 1,500 words for the AI-based text-to-image program MidJourney using the following parameters: /imagine prompt: [1], [2], [3], [4], [5], [6].\n\nIn this prompt, [1] should be replaced with a user-supplied concept and [2] should be a concise, descriptive summary of the subject. Ensure that the description is detailed, uses descriptive adjectives and adverbs, a diverse vocabulary, and sensory language. Offer context and background information regarding the subject and consider the image\'s perspective and point of view. Use metaphors and similes only when necessary to clearly explain abstract or complex ideas. Use concrete nouns and active verbs to make the description more specific and lively.\n\n[3] should be a concise summary of the scene\'s environment. Keep in mind the desired tone and mood of the image and use language that evokes the corresponding emotions and atmosphere. Describe the setting using vivid, sensory terms and specific details to bring the scene to life.\n\n[4] should be a concise description of the mood of the scene, using language that conveys the desired emotions and atmosphere.\n\n[5] should be a concise description of the atmosphere, using descriptive adjectives and adverbs to create the desired atmosphere while considering the overall tone and mood of the image.\n\n[6] should be a concise description of the lighting effect, including types of lights, displays, styles, techniques, global illumination, and shadows. Describe the quality, direction, color, and intensity of the light and how it impacts the mood and atmosphere of the scene. Use specific adjectives and adverbs to portray the desired lighting effect and consider how it will interact with the subject and environment.\n\nIt\'s important to remember that the descriptions in the prompt should be written together, separated only by commas and spaces, and should not contain any line breaks or colons. Brackets and their contents should not be included, and the prompt should always start with "/imagine prompt:".\n\nEnsure that the grammar is consistent and avoid using cliches or excess words. Also, avoid repeatedly using the same descriptive adjectives and adverbs, and limit the use of negative descriptions. Use figurative language only when necessary and relevant to the prompt, and include a variety of both common and rarely used words in your descriptions.\n\nThe "imagine prompt" must not exceed 1,500 words. The prompt should include the end arguments "--c X --s Y --q 2," where X is a whole number between 1 and 25 and Y is a whole number between 100 and 1000. If the subject looks better vertically, add "--ar 2:3" before "--c," and if it looks better horizontally, add "--ar 3:2" before "--c." Please randomize the end argument format and fix "--q 2." Donot use double quotation marks or punctuation marks, and use a randomized end suffix format.\n\nWait for a '.concat(concept, ' to be provided before generating the prompt."\n      ');
                break;
            }
        default:
            {
                magicStr = latestMagicString;
            }
    }
    return magicStr;
};
var systemLocaleTransformer = function(locale) {
    switch(locale){
        case _appConfig__WEBPACK_IMPORTED_MODULE_0__/* .SupportLocaleEnum.en */ .xM.en:
            return _generated_graphql_prompts_node__WEBPACK_IMPORTED_MODULE_1__/* .PromptSupportingLanguageMap.English */ .aN.English;
        case _appConfig__WEBPACK_IMPORTED_MODULE_0__/* .SupportLocaleEnum.zhTw */ .xM.zhTw:
            return _generated_graphql_prompts_node__WEBPACK_IMPORTED_MODULE_1__/* .PromptSupportingLanguageMap.MandarinChinese */ .aN.MandarinChinese;
        case _appConfig__WEBPACK_IMPORTED_MODULE_0__/* .SupportLocaleEnum.ja */ .xM.ja:
            return _generated_graphql_prompts_node__WEBPACK_IMPORTED_MODULE_1__/* .PromptSupportingLanguageMap.Japanese */ .aN.Japanese;
        default:
            return _generated_graphql_prompts_node__WEBPACK_IMPORTED_MODULE_1__/* .PromptSupportingLanguageMap.English */ .aN.English;
    }
};


/***/ })

}]);